import React from 'react';
import Typed from 'react-typed';

const AboutOne = () => {
    return (
        <div className="rwt-about-area rn-section-gap">
            <div className="container">
                <div className="row row--30 align-items-center">
                    <div className="col-lg-5">
                        <div className="thumbnail">
                            <img className="w-100" src="./images/ftd/about/about-1.png" alt="About Imagessss" />
                        </div>
                    </div>

                    <div className="col-lg-7 mt_md--40 mt_sm--40">
                        <div className="content">
                            <div className="section-title">
                                <h2 className="title">Cito Technology <br /> {" "}
                                    <Typed className="theme-gradient"
                                        strings={[
                                            "About Us",
                                            "Corporate",
                                            "Why We Are",
                                        ]}
                                        typeSpeed={80}
                                        backSpeed={5}
                                        backDelay={1000}
                                        loop
                                    />
                                </h2>
                                <p>
                                Cito Technology and Internet Services; is an expert company that produces turnkey projects in the fields of business process management and outsourcing, organizational efficiency and use of business intelligence.</p>
                                <div className="read-more-btn mt--40">
                                    <a className="btn-default" href="/about-us"><span>Detailed Information</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutOne
